"use client";

import { SlidersHorizontal } from "lucide-react";

import { cn } from "@/lib/utils/cn";

type ThresholdEditorProps = {
  summary: string | null;
  onOpen: () => void;
  className?: string;
};

/**
 * Compact control that opens the full threshold / validation modal.
 */
export function ThresholdEditor({ summary, onOpen, className }: ThresholdEditorProps) {
  return (
    <button
      type="button"
      onClick={onOpen}
      title={summary ?? "Configure limits, warnings, and type rules"}
      className={cn(
        "group flex w-full max-w-full items-center gap-ds-2 rounded-control bg-surface-secondary px-ds-3 py-ds-2.5 text-left transition-colors duration-200",
        "hover:bg-muted-bg/55 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--border-strong)] focus-visible:ring-offset-2 focus-visible:ring-offset-card",
        className,
      )}
    >
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-card text-muted shadow-sm ring-1 ring-border/50 transition-colors group-hover:text-foreground dark:bg-muted-bg/30">
        <SlidersHorizontal className="h-4 w-4" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-micro font-semibold uppercase tracking-[0.12em] text-muted">Thresholds</span>
        <span className="mt-0.5 block text-body leading-snug text-foreground">
          {summary ? <span className="line-clamp-2">{summary}</span> : <span className="text-muted">Set limits & warnings…</span>}
        </span>
      </span>
    </button>
  );
}
